import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const TabsBar = styled.div`
    border-bottom: 1px solid ${colors.divider};
    margin: 4px 0 24px;
`;
